.errorContainerWrapper {
    max-width: 1200px;
}

.title {
    font-weight: bold;
    font-size: 1.5em
}

.errorWrapper {
    margin: 16px 0;
    background-color: #fafafa;
    padding: 16px 32px;
}

.buttonWrapper {
    display: flex;
    justify-content: space-between
}

.errorCard {
    display: flex;
    justify: space-between;
    margin-bottom: 12px;
    background-color: #fff;
    padding: 12px;
    align-items: center
}

.errorDetails {
    display: flex;
    flex-direction: column
}

.errorResolution {
    text-align: right
}

.errorNameWrapper {
    margin-top: 12px;
}

.errorName {
    font-weight: bold
}

.errorTitle {
    font-weight: bold
}
.meetingSlotRange{
    display: flex;
    justify-content: space-between
}
